import { render, staticRenderFns } from "./gnyzpt.vue?vue&type=template&id=a38ec2f4"
import script from "./gnyzpt.vue?vue&type=script&lang=js"
export * from "./gnyzpt.vue?vue&type=script&lang=js"
import style0 from "./gnyzpt.vue?vue&type=style&index=0&id=a38ec2f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports